import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class OrganizationBillingService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getAll(isMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `invoicebilling?isMaintenance=${isMaintenance}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, isMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `invoicebilling/${id}?isMaintenance=${isMaintenance}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(model: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'invoicebilling', model).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(model: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + 'invoicebilling', model).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
        return this.httpClient.delete(this.baseApiUrl + `invoicebilling/${id}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'invoicebilling/authorise', id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number, sortColumn: string,
        sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };

        return this.httpClient.post(this.baseApiUrl + 'invoicebilling/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}